// All site copy lives here. Keep keys identical between languages.

export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      about: 'Sobre Mí',
      projects: 'Proyectos',
      resume: 'CV',
      contact: 'Contacto',
      langLabel: 'Cambiar idioma',
    },
    hero: {
      name: 'Raúl de la Fuente',
      title: 'Senior Brand Manager y Director Creativo',
      intro:
        'Construyo marcas que la gente recuerda. Me muevo entre la estrategia y la dirección creativa, con especial foco en el storytelling y la narrativa de marca. Porque las mejores campañas no solo venden, crean cultura.',
      cta: 'Ver Proyectos',
    },
    about: {
      title: 'Sobre Mí',
      p1: 'Mi primer oficio fue enseñar. Y enseñando descubrí que tenía una habilidad que no sabía que tenía: la de hacer que las cosas complejas parecieran simples, cercanas y memorables.',
      p2: 'Eso mismo es lo que llevo haciendo desde entonces, solo que con marcas. Empecé casi por accidente en el mundo del craft beer, sin manual, sin equipo, solo con criterio. Y funcionó. Desde ahí no he parado de construir identidades, campañas, líneas de negocio enteras, siempre con la misma pregunta de fondo: ¿qué historia tiene esta marca que vale la pena contar?',
      p3: 'La respuesta me ha llevado por muchas aventuras. Convencer a GOIKO de apostar por el gaming con una campaña de un año entero y terminar con un premio de marketing debajo del brazo. Construir Basics by GOIKO desde una hoja en blanco hasta verla convertida en una línea de negocio con vida propia y marcando tendencias. Lanzar marcas y conceptos en industrias completamente diferentes, cada una con sus reglas, su público y su forma de comunicar.',
      p4: 'Proyectos muy distintos, una sola pregunta constante: ¿cómo hacemos que esto valga la pena ser escuchado?',
      quote:
        '"Escucha, y te darás cuenta de que no estamos hechos de células o átomos. Estamos hechos de historias."',
      quoteAuthor: '— Mia Couto',
      expertiseTitle: 'Lo que hago bien',
      expertise: [
        'Dirección Creativa',
        'Estrategia de Marca',
        'Storytelling & Narrativa',
        'Campañas Full-Funnel',
        'Brand Building',
        'Expansión de Mercado',
        'Contenido Digital',
        'Alianzas & PR',
      ],
    },
    projects: {
      title: 'Proyectos Seleccionados',
      intro:
        'Una colección curada de trabajos recientes que abarcan estrategia de marca, desarrollo de campañas y dirección creativa.',
      moreAvailable: 'Proyectos adicionales disponibles bajo solicitud',
      objectivesLabel: 'Objetivos',
      resultsLabel: 'Impacto y Resultados',
      viewFull: 'Ver proyecto completo',
      counterImages: 'imágenes',
      items: [
        {
          projectName: 'Enjoy The Simple things: De Brief a Línea de Negocio',
          brand: 'Basics by GOIKO',
          year: '2019–2024',
          role: 'Brand Manager & Creative Director',
          description:
            'El fundador de GOIKO vio mi trabajo y me llamó para crear desde cero una marca street, joven y moderna dentro de uno de los grupos de restauración más importantes de España. Entré como paracaidista en una empresa establecida, con total libertad creativa y sin red. Concepto, identidad, tono, carta, experiencia de marca. Todo construido en menos de un mes.',
          objectives: [
            'Crear una marca con identidad propia que conectara con un público más joven que la marca madre',
            'Desarrollar conceptos de lanzamiento con impacto real en tráfico y notoriedad',
            'Escalar el modelo a múltiples puntos de venta en España',
          ],
          results:
            'Nuestro único local de Chueca se coló en el top 5 de facturación mensual dentro de una red de más de 100 restaurantes de GOIKO. Los lanzamientos como el Free Burger Day generaron colas de más de 2.000 personas. Los conceptos desarrollados fueron replicados por la marca madre. El rebranding posterior impulsó un crecimiento del +400% en ventas.',
          skills: ['Brand Building', 'Dirección Creativa', 'Lanzamiento de Producto', 'Campañas 360', 'Estrategia de Marca'],
        },
        {
          projectName: 'Game On MTFs: From Zero, To Hero',
          brand: 'GOIKO',
          year: '2020–2022',
          role: 'Gaming & Marketing Lead',
          description:
            'Durante la pandemia, mientras el mundo se paralizaba, los videojuegos se disparaban. Vi la oportunidad de meter a GOIKO en ese ecosistema: un territorio muy protegido donde las marcas no suelen ser bienvenidas. El reto era entrar de verdad, sin parecer oportunistas. El concepto fue From Zero to Hero: primero asumimos públicamente que no teníamos ni idea, aprendimos con la comunidad, creamos un mapa propio dentro de Fortnite con su propio storytelling, y cerramos la campaña patrocinando a uno de los equipos de esports más importantes del ecosistema.',
          objectives: [
            'Insertar la marca GOIKO en el ecosistema gamer de forma orgánica y creíble',
            'Generar notoriedad y engagement entre un público menor de 35 años',
            'Construir una estrategia de contenido sostenida a lo largo de un año completo',
          ],
          results:
            '+6.2M de impresiones totales y +550K views. El mapa de Fortnite generó un tiempo medio de juego de 34 minutos. GOIKO creció un 110% en Twitter, con el 79% de nuevos seguidores procedentes de activaciones gaming. La campaña ganó la Medalla de Bronce en los premios Best!N Food, compitiendo contra marcas con presupuestos diez veces superiores.',
          skills: ['Estrategia de Contenido', 'Gaming & Esports', 'Storytelling', 'Influencer Marketing', 'Campañas 360'],
        },
        {
          projectName: "Pink's!! x Dani Brasserie: Four Seasons Madrid",
          brand: "Pink's!!",
          year: '2025',
          role: 'Head of Brand Strategy',
          description:
            'El equipo de Dani Brasserie probó nuestras hamburguesas y quiso colaborar. Me encargué al 100% de conceptualizar y ejecutar la colaboración. Con motivo del Día de la Hamburguesa, reinterpretamos la Rossini Burger, el best seller de Dani Brasserie, en versión smash, y la servimos durante 4 días en la terraza del Hotel Four Seasons Madrid. Sin reservas, primera línea de Madrid, 200 unidades diarias hasta agotar.',
          objectives: [
            "Posicionar Pink's!! en el segmento premium sin perder su identidad de marca",
            'Crear una experiencia exclusiva con edición limitada como eje central',
            'Generar notoriedad a través de una colaboración con uno de los chefs más reconocidos de España',
          ],
          results:
            "200 unidades agotadas cada día de los 4 días del evento. Cada hamburguesa incluía una camiseta oficial numerada de la colaboración. Terraza llena en horario de 16:00 a 19:00. Cobertura en prensa especializada. Uno de los mayores hitos de marca en la historia de Pink's!!",
          skills: ['Brand Partnerships', 'Dirección Creativa', 'Experiencia de Marca', 'Estrategia de Marca', 'Edición Limitada'],
        },
        {
          projectName: "Perri's: Stay Classy",
          brand: "Pink's!!",
          year: '2025',
          role: 'Head of Brand Strategy & Creative Director',
          description:
            "Dentro de mi trabajo en Pink's!!, dirigí la conceptualización y lanzamiento de Perri's como nueva línea de negocio independiente. El concepto era claro desde el principio: el hot dog clásico, sin artificios, hecho con los ingredientes que importan. 'Stay Classy' no era solo un tagline — era la filosofía de marca que guió cada decisión creativa. Pero Perri's tenía además un modelo de negocio pionero en España: el primer restaurante por suscripción del país. Un fee mensual, un perrito gratis al día durante los 30 días del mes.",
          objectives: [
            'Crear una nueva línea de negocio con identidad visual y narrativa propias',
            'Desarrollar todos los touchpoints de marca: identidad visual, packaging, uniformes, diseño de local',
            'Lanzar el concepto con un modelo de negocio innovador y escalable',
          ],
          results:
            'Primer restaurante por suscripción de España. Marca construida de cero y lista para escalar — brandbook completo, línea de producto propia, colaboración con Cervecera Península para la house beer y apertura de local con experiencia de marca 360.',
          skills: ['Brand Building', 'Dirección Creativa', 'Identidad Visual', 'Lanzamiento de Producto', 'Estrategia de Marca'],
        },
        {
          projectName: 'Esta Navidad Hay un Sitio Reservado para ti.',
          brand: 'Telpark',
          year: '2025',
          role: 'Senior Brand & Content Manager',
          description:
            'En Telpark lideré la dirección creativa de la campaña de Navidad. La idea giraba alrededor de los momentos que las personas se pierden por estar buscando aparcamiento. Un insight cotidiano convertido en storytelling emocional dentro de un sector dominado por la comunicación puramente funcional.',
          objectives: [
            'Conectar el producto con momentos emocionales relevantes para el usuario',
            'Desarrollar una campaña con identidad propia dentro de un sector muy funcional',
            'Gestionar la relación con agencia creativa para garantizar coherencia de marca',
          ],
          results:
            'Campaña desplegada en canales digitales y punto de venta. Piezas visuales con alta coherencia de marca y concepto narrativo diferenciador en un sector dominado por comunicación puramente funcional.',
          skills: ['Dirección Creativa', 'Gestión de Agencias', 'Estrategia de Contenido', 'Comunicación de Marca'],
        },
        {
          projectName: 'Incógnito Smash',
          brand: 'Basics by GOIKO',
          year: '2021',
          role: 'Brand Manager & Creative Director',
          description:
            'Todo el mundo colabora con influencers de la misma forma: el influencer coge el producto, le pone su nombre y listo. Nosotros queríamos algo diferente. Ceci Army llevaba años construyendo una comunidad entera alrededor de un misterio: nadie le había visto la cara nunca. Eso era exactamente lo que necesitábamos. Creamos La Incógnito Smash, una hamburguesa sin ingredientes revelados. Sin pistas, sin spoilers. La única forma de descubrir qué había dentro era pedirla.',
          objectives: [
            'Crear una colaboración con influencer que rompiera con la mecánica habitual del sector',
            'Generar intriga y deseo de producto a través del misterio como concepto central',
            'Impulsar visitas al local y pedidos delivery con una mecánica de descubrimiento',
          ],
          results:
            'Miles de hamburguesas vendidas. Un evento privado para el círculo más cercano de Ceci Army que se convirtió en uno de los lanzamientos más comentados del momento. Pasamontañas conmemorativos como merchandising que la gente quería tener. Una campaña que funcionó en ventas, en prensa y sobre todo en conversación.',
          skills: ['Dirección Creativa', 'Influencer Marketing', 'Storytelling', 'Experiencia de Marca', 'Lanzamiento de Producto'],
        },
      ],
    },
    resume: {
      title: 'Currículum',
      intro: '¿Interesado en conocer más sobre mi experiencia y calificaciones?',
      download: 'Descargar CV — PDF',
      linkedInPre: 'También puedes conectar conmigo en',
      linkedInPost: ' para mi trayectoria profesional completa.',
    },
    contact: {
      title: 'Hablemos',
      intro: 'Siempre estoy interesado en escuchar sobre nuevas oportunidades y colaboraciones creativas.',
      emailLabel: 'Correo',
      linkedInLabel: 'LinkedIn',
      linkedInCta: 'Perfil de LinkedIn',
      formTitle: 'Enviar un Mensaje',
      name: 'Nombre',
      namePh: 'Tu nombre',
      email: 'Correo',
      emailPh: 'tu.correo@ejemplo.com',
      message: 'Mensaje',
      messagePh: 'Cuéntame sobre tu proyecto u oportunidad...',
      send: 'Enviar Mensaje',
      sending: 'Enviando…',
      errorFill: 'Por favor completa todos los campos.',
      success: '¡Mensaje enviado! Te responderé pronto.',
      error: 'No se pudo enviar el mensaje. Intenta de nuevo.',
    },
    footer: {
      rights: 'Todos los derechos reservados.',
      tagline: 'Diseñado con intención. Construido para impactar.',
    },
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About',
      projects: 'Projects',
      resume: 'CV',
      contact: 'Contact',
      langLabel: 'Switch language',
    },
    hero: {
      name: 'Raúl de la Fuente',
      title: 'Senior Brand Manager & Creative Director',
      intro:
        'I build brands that people remember. I work where strategy meets creative direction, with a sharp focus on storytelling and brand narrative. Because the best campaigns don\'t just sell — they create culture.',
      cta: 'View Projects',
    },
    about: {
      title: 'About Me',
      p1: 'My first job was teaching. And teaching is where I discovered a skill I didn\'t know I had: making complex things feel simple, close, and memorable.',
      p2: 'That\'s exactly what I\'ve been doing ever since, only with brands. I got into the craft beer world almost by accident — no playbook, no team, just instinct. And it worked. From there I\'ve never stopped building identities, campaigns, entire business lines, always asking the same question: what\'s the story this brand has worth telling?',
      p3: 'The answer has taken me to a lot of places. Convincing GOIKO to bet on gaming with a year-long campaign and walking out with a marketing award. Building Basics by GOIKO from a blank page into a business line with its own pulse, setting trends. Launching brands and concepts across completely different industries, each with its own rules, audience, and way of speaking.',
      p4: 'Very different projects, one constant question: how do we make this worth listening to?',
      quote:
        '"Listen, and you\'ll realize we\'re not made of cells or atoms. We\'re made of stories."',
      quoteAuthor: '— Mia Couto',
      expertiseTitle: 'What I do well',
      expertise: [
        'Creative Direction',
        'Brand Strategy',
        'Storytelling & Narrative',
        'Full-Funnel Campaigns',
        'Brand Building',
        'Market Expansion',
        'Digital Content',
        'Partnerships & PR',
      ],
    },
    projects: {
      title: 'Selected Projects',
      intro:
        'A curated selection of recent work across brand strategy, campaign development, and creative direction.',
      moreAvailable: 'Additional projects available on request',
      objectivesLabel: 'Objectives',
      resultsLabel: 'Impact & Results',
      viewFull: 'View full project',
      counterImages: 'images',
      items: [
        {
          projectName: 'Enjoy The Simple Things: From Brief to Business Line',
          brand: 'Basics by GOIKO',
          year: '2019–2024',
          role: 'Brand Manager & Creative Director',
          description:
            'GOIKO\'s founder saw my work and brought me in to build, from scratch, a street, young, modern brand inside one of Spain\'s biggest restaurant groups. I dropped in as an outsider into an established company with full creative freedom and no safety net. Concept, identity, tone, menu, brand experience — all built in under a month.',
          objectives: [
            'Build a brand with its own identity that could speak to a younger audience than the parent brand',
            'Develop launch concepts with real impact on traffic and awareness',
            'Scale the model to multiple locations across Spain',
          ],
          results:
            'Our single Chueca location broke into the top 5 monthly revenue spots within a network of 100+ GOIKO restaurants. Launches like Free Burger Day drew lines of over 2,000 people. Concepts we developed were later replicated by the parent brand. The subsequent rebrand drove +400% sales growth.',
          skills: ['Brand Building', 'Creative Direction', 'Product Launch', '360 Campaigns', 'Brand Strategy'],
        },
        {
          projectName: 'Game On MTFs: From Zero to Hero',
          brand: 'GOIKO',
          year: '2020–2022',
          role: 'Gaming & Marketing Lead',
          description:
            'During the pandemic, while the world ground to a halt, gaming exploded. I saw the chance to put GOIKO inside that ecosystem — a fiercely guarded space where brands aren\'t exactly welcome. The challenge was to get in for real, without looking opportunistic. The concept was From Zero to Hero: we publicly admitted we didn\'t know anything, learned alongside the community, built our own Fortnite map with its own storytelling, and closed the campaign sponsoring one of the most important esports teams in the scene.',
          objectives: [
            'Insert GOIKO into the gaming ecosystem organically and credibly',
            'Drive awareness and engagement among under-35 audiences',
            'Build a sustained content strategy across a full year',
          ],
          results:
            '+6.2M total impressions and +550K views. The Fortnite map delivered a 34-minute average play time. GOIKO grew 110% on Twitter, with 79% of new followers coming from gaming activations. The campaign won Bronze at the Best!N Food Awards, competing against brands with budgets ten times bigger.',
          skills: ['Content Strategy', 'Gaming & Esports', 'Storytelling', 'Influencer Marketing', '360 Campaigns'],
        },
        {
          projectName: "Pink's!! x Dani Brasserie: Four Seasons Madrid",
          brand: "Pink's!!",
          year: '2025',
          role: 'Head of Brand Strategy',
          description:
            "The Dani Brasserie team tried our burgers and wanted to collaborate. I owned the entire concept and execution end to end. For Burger Day, we reinterpreted the Rossini Burger — Dani Brasserie's best seller — as a smash, and served it for 4 days on the rooftop terrace of the Four Seasons Hotel Madrid. No reservations, prime Madrid skyline, 200 units a day until sold out.",
          objectives: [
            "Position Pink's!! in the premium segment without losing the brand's identity",
            'Build an exclusive experience with limited edition at the core',
            'Drive awareness through a collaboration with one of Spain\'s most respected chefs',
          ],
          results:
            "200 units sold out every day across the 4-day event. Each burger came with an official numbered collab t-shirt. The terrace was packed from 4 to 7 PM. Coverage in specialized press. One of the biggest brand milestones in Pink's!! history.",
          skills: ['Brand Partnerships', 'Creative Direction', 'Brand Experience', 'Brand Strategy', 'Limited Edition'],
        },
        {
          projectName: "Perri's: Stay Classy",
          brand: "Pink's!!",
          year: '2025',
          role: 'Head of Brand Strategy & Creative Director',
          description:
            "As part of my work at Pink's!!, I led the concept and launch of Perri's as a new, independent business line. The concept was clear from day one: the classic hot dog, no fluff, made with the ingredients that matter. 'Stay Classy' wasn't just a tagline — it was the brand philosophy that drove every creative decision. Perri's also came with a pioneering business model in Spain: the country's first subscription restaurant. A monthly fee, one free hot dog a day, every day of the month.",
          objectives: [
            'Create a new business line with its own visual and narrative identity',
            'Develop every brand touchpoint: visual identity, packaging, uniforms, retail design',
            'Launch the concept with an innovative, scalable business model',
          ],
          results:
            'First subscription-based restaurant in Spain. Brand built from scratch and ready to scale — complete brand book, own product line, collaboration with Cervecera Península for the house beer, and a flagship location with 360 brand experience.',
          skills: ['Brand Building', 'Creative Direction', 'Visual Identity', 'Product Launch', 'Brand Strategy'],
        },
        {
          projectName: 'This Christmas, There\'s a Spot Saved for You.',
          brand: 'Telpark',
          year: '2025',
          role: 'Senior Brand & Content Manager',
          description:
            'At Telpark I led the creative direction for the Christmas campaign. The idea revolved around the moments people miss while hunting for parking. A daily insight turned into emotional storytelling inside a sector dominated by purely functional communication.',
          objectives: [
            'Connect the product with emotional moments that actually matter to users',
            'Develop a campaign with its own identity inside a highly functional category',
            'Manage the creative agency relationship to guarantee brand consistency',
          ],
          results:
            'Campaign rolled out across digital channels and point of sale. Visual pieces with strong brand consistency and a distinctive narrative concept in a sector dominated by purely functional communication.',
          skills: ['Creative Direction', 'Agency Management', 'Content Strategy', 'Brand Communications'],
        },
        {
          projectName: 'Incógnito Smash',
          brand: 'Basics by GOIKO',
          year: '2021',
          role: 'Brand Manager & Creative Director',
          description:
            'Everyone does influencer collabs the same way: the influencer grabs the product, puts their name on it, done. We wanted something different. Ceci Army had spent years building an entire community around a single mystery: no one had ever seen his face. That was exactly what we needed. We created La Incógnito Smash, a burger with no disclosed ingredients. No clues, no spoilers. The only way to find out what was inside was to order it.',
          objectives: [
            'Build an influencer collab that broke the category\'s default playbook',
            'Generate intrigue and product desire using mystery as the core concept',
            'Drive in-store visits and delivery orders through a discovery mechanic',
          ],
          results:
            'Thousands of burgers sold. A private event for Ceci Army\'s inner circle that became one of the most talked-about launches of the moment. Commemorative balaclavas as merch that people actually wanted. A campaign that worked in sales, in press, and most importantly, in conversation.',
          skills: ['Creative Direction', 'Influencer Marketing', 'Storytelling', 'Brand Experience', 'Product Launch'],
        },
      ],
    },
    resume: {
      title: 'Resume',
      intro: 'Want to know more about my experience and background?',
      download: 'Download CV — PDF',
      linkedInPre: 'You can also connect with me on',
      linkedInPost: ' for my full professional track record.',
    },
    contact: {
      title: 'Let\'s Talk',
      intro: 'Always interested in hearing about new opportunities and creative collaborations.',
      emailLabel: 'Email',
      linkedInLabel: 'LinkedIn',
      linkedInCta: 'LinkedIn Profile',
      formTitle: 'Send a Message',
      name: 'Name',
      namePh: 'Your name',
      email: 'Email',
      emailPh: 'your.email@example.com',
      message: 'Message',
      messagePh: 'Tell me about your project or opportunity...',
      send: 'Send Message',
      sending: 'Sending…',
      errorFill: 'Please fill in all fields.',
      success: 'Message sent! I\'ll get back to you soon.',
      error: 'Couldn\'t send the message. Please try again.',
    },
    footer: {
      rights: 'All rights reserved.',
      tagline: 'Designed with intent. Built to land.',
    },
  },
};
